'use client';

import React from 'react';
import { useIsMounted } from './useIsMounted';
import { usePrevious } from './usePrevious';

export const useGetSnapshotBeforeUpdate = <Props, State, Snapshot>(
  onPreRender: (prevProps: Props, prevState: State) => Snapshot,
  props: Props,
  state: State,
): ((onEffect: (prevProps: Props, prevState: State, snapshot: Snapshot) => void) => void) => {
  const { props: prevProps = undefined, state: prevState = undefined } = usePrevious({ props, state }) ?? {};
  const snapshot = React.useRef<Snapshot | null>(null);
  const idMounted = useIsMounted();

  React.useLayoutEffect(() => {
    if (idMounted) {
      snapshot.current = onPreRender(prevProps as Props, prevState as State);
    }
  });

  const useComponentDidUpdate = (onEffect: (prevProps: Props, prevState: State, snapshot: Snapshot) => void) => {
    React.useEffect(() => {
      if (idMounted) {
        onEffect(prevProps as Props, prevState as State, snapshot.current as Snapshot);
      }
    });
  };

  return useComponentDidUpdate;
};
